export default __webpack_public_path__ + "static/media/ic-stock-class.b572eaa3.svg";